async function rawRequest(path, options = {}) {
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData)) headers.set('Content-Type', 'application/json');
  return fetch(path, { ...options, headers, credentials: 'include' });
}

export async function api(path, options = {}, allowRefresh = true) {
  let response = await rawRequest(path, options);
  if (response.status === 401 && allowRefresh && !['/api/auth/login', '/api/auth/admin-login', '/api/auth/refresh'].includes(path)) {
    const refreshed = await rawRequest('/api/auth/refresh', { method: 'POST' });
    if (refreshed.ok) response = await rawRequest(path, options);
  }
  if (response.status === 204) return null;
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const validationMessage = payload.error === 'Date invalide.' && Array.isArray(payload.details) ? payload.details[0]?.message : '';
    throw Object.assign(new Error(validationMessage || payload.error || 'Cererea nu a putut fi finalizată.'), payload, { status: response.status, details: payload.details });
  }
  return payload;
}

export function buildQuery(values) {
  const query = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => { if (value !== '' && value != null) query.set(key, value); });
  return query.toString();
}
